export default __webpack_public_path__ + "static/media/yuzu.586a7ac5.svg";